import CONSTANTS from '../../../constants';

export function categories(state = { data: null, loading: true }, action) {
  if (action.type === CONSTANTS.ACTIONS.CATEGORY.CATEGORY_ALL) {
    const { data } = action;
    return { data: data ? data.response : data, loading: action.loading};
  }
  return state;
}